module.exports = __webpack_public_path__ + "img/delay_4.a0e116a1.svg";